import { Classroom } from 'types/classroom';

export function hasSimpleMapping(
  srcClassrooms: Classroom[],
  destClassrooms: Classroom[],
) {
  return (
    destClassrooms.length === 1 &&
    srcClassrooms.length === 1 &&
    srcClassrooms[0] &&
    destClassrooms[0]
  );
}
